<div *ngIf="!templates.length" class="place-self-center">
  <mat-spinner [diameter]="32"></mat-spinner>
</div>

<div
  *ngIf="templates.length > 0"
  class="grid"
  [ngClass]="(isMobile$ | async) ? 'justify-center text-center' : 'grid-cols-[auto_1fr] gap-16 items-center'">
  <div>
    <h2 class="m-0 mb-4">Pick a template for your site</h2>
    <p class="m-0 mb-6">Find the theme that best matches your property portfolio</p>

    <div
      class="grid gap-6 overflow-auto overflow-x-hidden max-h-[50vh]"
      [ngClass]="{
        'grid-cols-2': !(isMobile$ | async)
      }">
      <sbnb-direct-template-light
        *ngFor="let template of templates"
        [template]="template"
        [isSelected]="selectedTemplateId === template.id"
        (selectTemplate)="switchTemplate(template.id)"></sbnb-direct-template-light>
    </div>

    <div class="flex gap-4 mt-8" [ngClass]="{ 'justify-center': isMobile$ | async }">
      <sbnb-button type="secondary" [disabled]="loading" (click)="skip()">Skip</sbnb-button>
      <sbnb-button [loading]="loading" (click)="updateSiteTemplate()">Continue</sbnb-button>
    </div>
  </div>

  <iframe
    *ngIf="!(isMobile$ | async)"
    [src]="iframeSrc"
    frameborder="0"
    class="w-full aspect-video border border-smoke overflow-x-hidden"
    style="zoom: 0.7"></iframe>
</div>
